import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '.'

export const enum ProposalStatus {
  Paid = 'paid',
  Funded = 'funded',
  Closed = 'Closed',
}

export type Proposal = {
  id: string
  title: string
  status: ProposalStatus
  amount: number | null
  space: string
}

export type ProposalAmount = {
  proposalId: string
  amount: number | null
  status: ProposalStatus
  currency: string
}

export type ProposalState = {
  proposals: Proposal[] | null
  currentProposal: Proposal | null
}

const initialState: ProposalState = {
  proposals: null,
  currentProposal: null,
}

export const proposalsSlice = createSlice({
  name: 'proposals',
  initialState,
  reducers: {
    setProposals: (state, action: PayloadAction<Proposal[]>) => {
      state.proposals = action.payload
    },
    setAmount: (state, action: PayloadAction<ProposalAmount>) => {
      const proposal = state.proposals?.find((proposal) => proposal.id === action.payload.proposalId)
      if (proposal) {
        proposal.amount = action.payload.amount
        proposal.status = action.payload.status
      }
    },
    setCurrentProposal: (state, action: PayloadAction<Proposal | null>) => {
      state.currentProposal = action.payload
    },
    reset: (state) => {
      state.proposals = null
      state.currentProposal = null
    },
  },
})

export const { setProposals, setAmount, setCurrentProposal, reset } = proposalsSlice.actions

export const selectCurrentProposal = (state: RootState): Proposal | null => {
  return state.proposals.currentProposal
}

export const selectAllProposals = (state: RootState): Proposal[] | null => {
  return state.proposals.proposals
}

export default proposalsSlice.reducer
